import { BrandMark } from "./BrandMark";

const GUACCI = "https://farmaciaguacci.it/brahma-golden-pb-50ml";

export const Footer = () => (
  <footer className="bg-[#161410] py-14 text-white/60">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 md:grid-cols-3 lg:px-10">
      <div>
        <div className="flex items-center gap-3">
          <BrandMark className="h-8 w-8" />
          <span className="font-display text-xl tracking-[0.28em] text-ivory">BRAHMA</span>
        </div>
        <p className="mt-3 text-[10px] uppercase tracking-[0.3em] text-gold">
          by Pómalab · anti-age · postbiotics technology
        </p>
      </div>
      <div className="text-sm font-light leading-relaxed">
        <p className="text-[10px] uppercase tracking-[0.28em] text-gold">Dati societari</p>
        <p className="mt-3">Pomalab Srl</p>
        <p>Via Cristoforo Colombo 10, Formia (LT)</p>
        <p>P.IVA 03292510595 · REA LT-325062</p>
        <p>PEC: pomalab@legalmail.it</p>
      </div>
      <div className="text-sm font-light">
        <p className="text-[10px] uppercase tracking-[0.28em] text-gold">Link utili</p>
        <div className="mt-3 flex flex-col gap-2">
          <a
            href="https://pomalab.it"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-pomalab-link"
            className="transition-colors duration-300 hover:text-gold"
          >
            pomalab.it — sito ufficiale
          </a>
          <a
            href={GUACCI}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-guacci-link"
            className="transition-colors duration-300 hover:text-gold"
          >
            Acquista da Farmacia Guacci
          </a>
          <a
            href="https://www.youtube.com/watch?v=Ms3ntR2p7-0"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-youtube-link"
            className="transition-colors duration-300 hover:text-gold"
          >
            "Dieci e Venticinque" su YouTube
          </a>
        </div>
      </div>
    </div>
    <div className="mx-auto mt-12 max-w-7xl border-t border-white/10 px-5 pt-6 text-center text-xs font-light tracking-wide lg:px-10">
      © {new Date().getFullYear()} Pomalab Srl. Tutti i diritti riservati.
    </div>
  </footer>
);
